// // Use $ instead of $uery without replacing global $
(function ($) {

  // $(document).ready(function () {
  //   var flag = 0;
  //
  //   //init for images slider
  //   $("body .image-slider .content-wrapper .slider-wrapper .card").on("click", function () {
  //     $('.image-slider .slider-wrap').fadeIn();
  //     $('.image-slider').addClass('open-overlay');
  //
  //     if (flag == 0) {
  //       $('.overlay .slick-item-wrap .slider-wrap').slick({
  //         dots: false,
  //         infinite: false,
  //         speed: 800,
  //         slidesToShow: 1,
  //         arrows: true,
  //         // focusOnSelect: true,
  //         autoplay: false,
  //         draggable: false,
  //         // adaptiveHeight: true,
  //         fade: true,
  //         prevArrow: $('.image-slider  .outer-slide-nav .slide-prev'),
  //         nextArrow: $('.image-slider  .outer-slide-nav .slide-next'),
  //         asNavFor: '.image-slider .slider-wrapper',
  //       });
  //
  //       $('body .image-slider .overlay  .item .col-three .inner-slider').slick({
  //         dots: true,
  //         infinite: false,
  //         speed: 800,
  //         slidesToShow: 1,
  //         arrows: true,
  //         autoplay: false,
  //         draggable: false,
  //         fade: true,
  //       });
  //
  //       flag = 1;
  //     }
  //     setTimeout(function () {
  //       setArrow();
  //     }, 200);
  //
  //   });
  //
  //
  //   $('.image-slider .slider-wrapper').slick({
  //     dots: false,
  //     infinite: false,
  //     speed: 800,
  //     slidesToShow: 1,
  //     arrows: false,
  //     draggable: false,
  //     focusOnSelect: true,
  //     autoplay: false,
  //     asNavFor: '.overlay .slick-item-wrap .slider-wrap'
  //   });
  //
  //
  //   //  Remove overlay Close Button click
  //   $(".image-slider .overlay .close-btn").click(function () {
  //     // $('.image-slider').removeClass('active');
  //     $('.image-slider').removeClass('open-overlay');
  //     $(".image-slider .overlay .slider-wrap").fadeOut();
  //   });
  //
  //   //  Remove overlay document click
  //   $(".image-slider .overlay").click(function () {
  //     // $('.image-slider').removeClass('active');
  //     $('.image-slider').removeClass('open-overlay');
  //     $(".image-slider .overlay .slider-wrap").fadeOut();
  //   });
  //
  //   $(".image-slider .overlay .slick-item-wrap").click(function (e) {
  //     e.stopPropagation();
  //   });
  //
  //
  //   function setArrow() {
  //     var count = $('body .image-slider .slick-item-wrap .item.slick-current  .slick-dots li').length;
  //     var width = $('body .image-slider .slick-item-wrap .item.slick-current .slick-dots li').outerWidth();
  //     // console.log('count', count);
  //     // console.log('width', width);
  //     var total = count * width + 25;
  //     $('body .image-slider .overlay .inner-wrap .slick-item-wrap .slider-wrap .item .col-three .slick-arrow.slick-prev').css({"right": total + "px"});
  //   }
  //
  //
  //   $('.image-slider .overlay  .outer-slide-nav .slide-prev').on("click", function () {
  //     setTimeout(function () {
  //       setArrow();
  //     });
  //   });
  //
  //   $('.image-slider .overlay  .outer-slide-nav .slide-next').on("click", function () {
  //     setTimeout(function () {
  //       setArrow();
  //     });
  //   });
  //
  // });


  $(document).ready(function () {
    var slider_image = $('.image-slider .content-wrapper .slider-wrapper .inner-wrap .bg-img img ');
    objectFitImages(slider_image);
  });

})(jQuery);